export default {
    SET_INTRO_DISPLAYED (state, status) {
      // state.isStatusIntroDisplayed = status
      state.statusIntroDisplayed = status
    }
  }
